module.exports = __webpack_public_path__ + "media/assets/services_manager/google-play-aa5e393e37a7f3346ce9f752e368a621548c4e03a75fcc3cd3f9758f39820eb9.svg";